import { ICompany } from '@collections/companies/interfaces/company.interface';
import { AppPageType } from '../google-tag-manager/analytics/data-layer-custom-dimensions';

export const XDEFAULT_LANG = 'en';

export interface PageMetadata {
  title: string;
  images: string[];
  description: string;
  keywords: string[];
  pageType: AppPageType;
  authorId?: string;
  authorUrl?: string;
  publishDate?: string;
  categories?: string[];
  company?: ICompany;
  url?: string;
  newsTitle?:string;
}


export enum RobotsIndexEnum {
  'index_follow' = 'index, follow',
  'index_nofollow' = 'index, nofollow',
  'noindex_follow' = 'noindex, follow',
  'noindex_nofollow' = 'noindex, nofollow',
  'index_follow_image' = 'index, follow, max-image-preview:large',
  'index_nofollow_image' = 'index, nofollow, max-image-preview:large',
  'noindex_follow_image' = 'noindex, follow, max-image-preview:large',
  'noindex_nofollow_image' = 'noindex, nofollow, max-image-preview:large'
}

export const defaultMetadata: PageMetadata = {
  title: 'default title',
  images: [],
  description: 'App description',
  keywords: [],
  pageType: 'website',
};
